import { ff } from "./feature-flags";

/**
 * Register PWA service worker.
 * Only activates when ff.pwa is enabled.
 */
export async function registerServiceWorker(): Promise<void> {
  if (!ff.pwa) return;
  if (!("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });

    // Auto-update check every 60 minutes
    setInterval(() => {
      registration.update();
    }, 60 * 60 * 1000);

    // Notify user when new version available
    registration.addEventListener("updatefound", () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener("statechange", () => {
        if (
          newWorker.state === "activated" &&
          navigator.serviceWorker.controller
        ) {
          // New content available — could show a toast here
          console.info("[PWA] Nouvelle version disponible. Rechargez la page.");
        }
      });
    });
  } catch (err) {
    console.warn("[PWA] Service worker registration failed:", err);
  }
}

/**
 * Unregister service worker (when ff.pwa is turned off).
 */
export async function unregisterServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const registration of registrations) {
    await registration.unregister();
  }
}
